<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="5. Australian Yellowleaf Lettuce">
<div class="titlepage">
<div>
<div>
<h1 class="title"><a id="d0e187" xmlns:saxon="http://icl.com/saxon">5.
                            Australian Yellowleaf Lettuce </a></h1><a id="d0e187" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e187" xmlns:saxon="http://icl.com/saxon">
<div>
<h3 class="subtitle">
<i>Lactuca sativa</i>
</h3>
</div>
</a></div><a id="d0e187" xmlns:saxon="http://icl.com/saxon">
</a></div><a id="d0e187" xmlns:saxon="http://icl.com/saxon">
<div class="epigraph">
<p>In Greece, lettuce is still viewed as an “antiaphrodisiac” as, according to
                    ancient Greek myth, the perhaps libidinally overambitious Adonis was transformed
                    into a wilting head of lettuce by Zeus for attempting to woo Hera from him. </p>
</div>
<p>Lettuce is another ancient vegetable family that, while permuting into a thousand
                variations on a theme, has at the same time remained extremely close to its wild
                roots. A relative of chicory, the Lactuca sativa family is a descendant of the
                bitter wild lettuce (<span class="emphasis"><em>Lactuca scariola</em></span>) native
                to Asia Minor and the trans-Caucasus. The milder, more reﬁned var. <span class="emphasis"><em>sativa</em></span> is believed to have originated in the
                Mediterranean region, but has been found growing as far aﬁeld as Europe, Africa, and
                the Near East since recorded time. Both the common and Latin names of lettuce have
                their roots in one of its most prominent characteristics: the milky, mildly soporiﬁc
                juice it releases when cut or bruised. The word <span class="emphasis"><em>lettuce</em></span> derives from the French <span class="emphasis"><em>laitue,</em></span> meaning “milky,” and this genus’s Latin name <span class="emphasis"><em>Lactuca</em></span> comes from the Latin word for milk.</p>
<p>According to Herodotus, the virtues of lettuce, or <span class="emphasis"><em>kahn,</em></span> were being extolled by the kings of Persia as early
                as the sixth century B.C., Persia also being home to one of the more prominently
                unfortunate pieces of vegetable lore. It seems that, in order to avoid contention
                over the throne in the earliest days of his reign, the Emperor Cambyses had his
                younger brother Smerdis put to death. One day soon afterwards, his grief-stricken
                sister plucked a head of lettuce from her luncheon plate and, ﬂamboyantly stripping
                away its leaves, asked her brother whether the result pleased him. When Cambyses
                replied that the lettuce was nothing without its leaves, his sister responded: “It
                is the same with our family; you have just cut off a precious sprout.” Not taking
                this as well as he might have, Cambyses, within a matter of hours, had her put to
                death as well.</p>
<p>Many botanists feel that the loose-leaf varieties of lettuce were the earliest
                incarnations of the <span class="emphasis"><em>Lactuca sativa</em></span> clan, and
                they have existed in a whole range of colors, stripings, and dapplings since very
                early in the recorded history of vegetables. However, the beautiful variety
                Australian Yellowleaf is pretty much unique in this vast family. True, among the
                varied greens and reds and bronzes of the lettuce family there are some nice,
                bright, yellow-green forms but, to my knowledge, there’s not a single other
                vegetable of any breed to compare with the true, brilliant chartreuse of this
                enchanting Australian heirloom. Extremely large, loose-growing, frilly-edged heads
                are genuinely like spots of neon yellow color in the garden, providing stunning and
                unique contrast to the surrounding hues of its neighbors. Australian Yellowleaf
                Lettuce boasts the additional commendable qualities of a sweet, tender, nonﬁbrous
                texture and a winningly slow-bolting habit.</p>
<p>As John Gerard noted in his <span class="emphasis"><em>Herball</em></span> of 1636,
                “Lettuce is a cold and moist pot-herbe...” and is best grown either early or late in
                the season, although Australian Yellowleaf will weather the heat of summer better
                than most. Start this sunny beauty 3 or 4 weeks before your frost date in seed cups
                indoors and plant out (or direct seed) after danger of frost. Thin to 8 to 10 inches
                apart and you should be enjoying these dazzling, frilly heads in about 50 days. Why
                not toss the leaves of this garden stunner with some currant tomatoes, a squeeze of
                lemon, a clove of garlic, a drizzle of good olive oil, and a shake each of salt and
                pepper?</p>
<div class="mediaobject" title="This is an image of Australian Yellowleaf Lettuce.">
<img alt="5. Australian Yellowleaf Lettuce" src="images/3.jpg"/>
<div class="caption">
<p>Australian Yellowleaf Lettuce</p>
</div>
</div>
</a></div><a id="d0e187" xmlns:saxon="http://icl.com/saxon">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch06.vue?36fdeaec